import { useEffect, useState } from 'react'

const useFlightBookForm = setMoreThan9 => {
  const [inputs, setInputs] = useState({
    originregioncode: 'u',
    destregioncode: 'u',
    depart_time: 'a',
    return_time: 'a',
    travelers: 1,
    travelerssnr: 0,
    travelerschd: 0,
    travelersinf: 0,
    travelersinfSeat: 0,
    travelersinfLap: 0,
    cabin: 'e',
    try_search: 1,
    ref: 'ha',
    alertMessage: false,
    firstLoad: true
  })
  const passengerCount =
    inputs.travelerssnr +
    inputs.travelerschd +
    inputs.travelers +
    inputs.travelersinfSeat

  const handleInputChange = event => {
    event.persist()
    if (event.target.name !== 'cabin') {
      setMoreThan9(false)
    }
    if (event.target.id === 'travelersMobMinus') {
      if (event.target.getAttribute('value') > 0) {
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) - 1,
          alertMessage: false
        }))
      }
    } else if (event.target.id === 'travelersMobPlus') {
      if (event.target.getAttribute('value') < 9 && passengerCount < 9) {
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) + 1,
          alertMessage: false
        }))
      } else {
        setMoreThan9(true)
        setInputs(prevState => ({ ...prevState, alertMessage: true }))
      }
    } else if (event.target.id === 'childMobMinus') {
      if (event.target.getAttribute('value') > 0)
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) - 1
        }))
      setInputs(prevState => ({ ...prevState, alertMessage: false }))
    } else if (event.target.id === 'childMobPlus') {
      if (event.target.getAttribute('value') < 8 && passengerCount < 9) {
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) + 1,
          alertMessage: false
        }))
      } else {
        setMoreThan9(true)
        setInputs(prevState => ({ ...prevState, alertMessage: true }))
      }
    } else if (event.target.id === 'seniourMobMinus') {
      if (event.target.getAttribute('value') > 0)
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) - 1
        }))
      setInputs(prevState => ({ ...prevState, alertMessage: false }))
    } else if (event.target.id === 'seniourMobPlus') {
      if (event.target.getAttribute('value') < 9 && passengerCount < 9) {
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) + 1,
          alertMessage: false
        }))
      } else {
        setMoreThan9(true)
        setInputs(prevState => ({ ...prevState, alertMessage: true }))
      }
    } else if (event.target.id === 'infantSeatMobMinus') {
      if (event.target.getAttribute('value') > 0)
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) - 1
        }))
      setInputs(prevState => ({ ...prevState, alertMessage: false }))
    } else if (event.target.id === 'infantSeatMobPlus') {
      if (event.target.getAttribute('value') < 8 && passengerCount < 9) {
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) + 1,
          alertMessage: false
        }))
      } else {
        setMoreThan9(true)
        setInputs(prevState => ({ ...prevState, alertMessage: true }))
      }
    } else if (event.target.id === 'infantLapMobMinus') {
      if (event.target.getAttribute('value') > 0)
        setInputs(prevState => ({
          ...prevState,
          [event.target.getAttribute('name')]:
            parseInt(event.target.getAttribute('value')) - 1
        }))
      setInputs(prevState => ({ ...prevState, alertMessage: false }))
    } else if (event.target.id === 'infantLapMobPlus') {
      setInputs(prevState => ({
        ...prevState,
        [event.target.getAttribute('name')]:
          parseInt(event.target.getAttribute('value')) + 1,
        alertMessage: false
      }))
    } else if (event.target.id === 'resetAllPassengers') {
      setInputs(prevState => ({
        ...prevState,
        cabin: 'e',
        travelers: 1,
        travelerssnr: 0,
        travelerschd: 0,
        travelersinf: 0,
        travelersinfSeat: 0,
        travelersinfLap: 0
      }))
    } else {
      setInputs(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }))
    }
  }

  useEffect(() => {
    if (inputs.firstLoad) {
      setInputs(prevState => ({
        ...prevState,
        cabin: window.sessionStorage.getItem('cabin')
          ? window.sessionStorage.getItem('cabin')
          : 'e',
        travelers: window.sessionStorage.getItem('travelers')
          ? parseInt(window.sessionStorage.getItem('travelers'))
          : 1,
        travelerssnr: window.sessionStorage.getItem('travelerssnr')
          ? parseInt(window.sessionStorage.getItem('travelerssnr'))
          : 0,
        travelerschd: window.sessionStorage.getItem('travelerschd')
          ? parseInt(window.sessionStorage.getItem('travelerschd'))
          : 0,
        travelersinf: window.sessionStorage.getItem('travelersinf')
          ? parseInt(window.sessionStorage.getItem('travelersinf'))
          : 0,
        travelersinfSeat: window.sessionStorage.getItem('travelersinfSeat')
          ? parseInt(window.sessionStorage.getItem('travelersinfSeat'))
          : 0,
        travelersinfLap: window.sessionStorage.getItem('travelersinfLap')
          ? parseInt(window.sessionStorage.getItem('travelersinfLap'))
          : 0
      }))
    } else {
      window.sessionStorage.setItem('cabin', inputs.cabin.toLowerCase())
      window.sessionStorage.setItem('travelers', inputs.travelers)
      window.sessionStorage.setItem('travelerschd', inputs.travelerschd)
      window.sessionStorage.setItem('travelerssnr', inputs.travelerssnr)
      window.sessionStorage.setItem('travelersinfSeat', inputs.travelersinfSeat)
      window.sessionStorage.setItem('travelersinfLap', inputs.travelersinfLap)
    }
  }, [inputs])

  return {
    handleInputChange,
    inputs,
    setInputs
  }
}

export default useFlightBookForm
